import NumberFormat from "react-number-format";

const DetailCard = ({ item }) => {
  const priceAfterDiscount =
    item.originalPrice - (item.originalPrice * item.discountPercent) / 100;
  return (
    <div className=" w-full sm:w-[700px] h-96 left-0 right-0 ml-auto mr-auto pt-5 sm:flex">
      <div className="w-full sm:w-1/2 sm:border sm:mr-3">
        <div>
          <img
            src={`/pic/${item.image}`}
            alt={item.name}
            className="w-[95%] rounded-lg m-2 mx-auto"
          />
        </div>
        <div className="grid grid-cols-4 mt-5 mx-6 gap-2">
          <div className=" text-center align-middle py-5 bg-slate-300">
            <span className="">1</span>
          </div>
          <div className=" text-center align-middle py-5 bg-slate-200">
            <span className="">2</span>
          </div>
          <div className=" text-center align-middle py-5 bg-slate-200">
            <span className="">3</span>
          </div>
          <div className=" text-center align-middle py-5 bg-slate-200">
            <span className="">4</span>
          </div>
        </div>
      </div>
      <div className="sm:w-1/2 p-3">
        <h1 className="text-3xl font-extrabold">
          <span>{item.name},</span> <span>{item.description}</span>
        </h1>
        <h1 className="text-sm font-semibold text-gray-400 ">By LeumangShop</h1>
        <div className="flex gap-2 my-3">
          <div>
            <h1 className="text-3xl font-bold">
              <NumberFormat
                value={priceAfterDiscount}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix={"Rp "}
              />
            </h1>
          </div>
          <div>
            {item.discountPercent > 0 && (
              <p className="text-lg font-bold">
                <NumberFormat
                  value={item.discountPercent}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  prefix={"Save "}
                />
                %
              </p>
            )}
            <span className="text-sm">Sudah Termasuk Pajak</span>
          </div>
        </div>
        <span className="text-sm">
          Enim esse voluptate laboris culpa nulla. Sunt mollit consequat irure
          culpa duis reprehenderit. Voluptate velit ullamco excepteur ad ad anim
          occaecat. Irure cillum qui deserunt est enim exercitation culpa ut
          voluptate elit voluptate.
        </span>
        <br />
        <button className="text-lg mt-3 font-bold rounded-2xl w-full h-10 text-white bg-[#6A983C] border-solid border-[#46760A] hover:bg-[#598033] hover:shadow-lg focus:bg-[#4a692a] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-200 active:shadow-lg transition duration-150 ease-in-out ">
          Buy Now
        </button>
      </div>
    </div>
  );
};

export default DetailCard;
